import { CONSUMER_FE_URL } from '../helpers/globals';

export const brokerageOfferPath = (token, slug) => `/brokerage-offers/${token}/${slug}`;

export const sellerFlowPagePath = ({ token, slug = '', inApp = false }) => {
  let path = slug ? `/seller-lead/${token}/${slug}` : `/seller-lead/${token}`;
  if (inApp) {
    path = `${path}?app=1`;
  }
  return path;
};

export const sellerGlobalPagePath = ({ token, page, inApp = false }) => {
  let path = `/seller-lead/${token}/p/${page}`;
  if (inApp) {
    path = `${path}?app=1`;
  }
  return path;
};

export const bffSellerGlobalPagePath = ({ token, page, inApp = false }) => {
  return CONSUMER_FE_URL + sellerGlobalPagePath({ token, page, inApp });
};

export const errorPagePath = '/error';

export const sellerOfferPagePath = ({ token, page }) => {
  return `/seller-offer/${token}${page && '/' + page}`;
};
